import { ActionReducerMapBuilder, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { IChallengesState } from ".";

interface IActionChallengesResponse {
    result: boolean;
}

export const actionChallenge = createAsyncThunk<IActionChallengesResponse, number>(
    'actionChallenge',
    async (challengeId: number) => await api.challenges.action(challengeId)
);

const actionChallengeHandler = (builder: ActionReducerMapBuilder<IChallengesState>) => {
    builder
        .addCase(actionChallenge.pending, (state: IChallengesState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(actionChallenge.fulfilled, (state: IChallengesState) => {
            state.loading = false;
        })
        .addCase(actionChallenge.rejected, (state: IChallengesState) => {
            state.loading = false;
            state.error = 'Unable to perform action for challenge';
        });
};

export default actionChallengeHandler;